import React from 'react';
import { TextLink as Link } from '@vds/buttons';
import PropTypes from 'prop-types';

const TextLink = (props) => (
  <Link
    type={props.type}
    ariaLabel={props.ariaLabel}
    data-track={props.dataTrack}
    color={props.color}
    disabled={props.disabled}
    id={props.id}
    href={props.href}
    onClick={props.onClick}
    size={props.size}
    bold={props.bold}
    role={props?.role}
    onKeyDown={props?.onKeyDown}
  >
    {props.children}
  </Link>
);
export default TextLink;

TextLink.defaultProps = {
  bold: false,
  color: '#000000',
  disabled: false,
  type: 'inline',
  role: 'link',
};

TextLink.propTypes = {
  type: PropTypes.oneOf(['inline', 'standAlone']),
  role: PropTypes.oneOf(['link', 'button']),
  ariaLabel: PropTypes.string,
  color: PropTypes.oneOf(['#0088ce', '#000000']),
  disabled: PropTypes.bool,
  id: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  size: PropTypes.oneOf(['large', 'small']),
  bold: PropTypes.bool,
  children: PropTypes.any,
  dataTrack: PropTypes.any,
};
